const state = {
    isSideNavExpanded: false,
    apiErrorMessage: '',
    quickMenuRequest: 0
};

const mutations = {
    setExpanded(state, expanded){
        state.isSideNavExpanded = expanded;
    },
    toggleSideNav(state) {
        var newState = !state.isSideNavExpanded
        state.isSideNavExpanded = newState;
    },
    setApiError(state, apiErrorMessage){
        state.apiErrorMessage = apiErrorMessage;
    },
    requestQuickMenu(state) {
        state.quickMenuRequest += 1;
    }
}

export const global = {
    namespaced: true,
    state,
    mutations
};